function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "wallet"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19 7v-1c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm-14-2h11c.551 0 1 .448 1 1v1h-12c-.551 0-1-.448-1-1s.449-1 1-1zm14 14h-14c-.551 0-1-.448-1-1v-9.171c.313.11.649.171 1 .171h14c.551 0 1 .448 1 1v1h-2c-1.654 0-3 1.346-3 3s1.346 3 3 3h2v1c0 .552-.449 1-1 1zm1-6v2h-2c-.551 0-1-.448-1-1s.449-1 1-1z"
}));

var Svg129Wallet = function Svg129Wallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg129Wallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/129-wallet.a63bf01b.svg";
export { ForwardRef as ReactComponent };